import { Button } from "@mui/material";
import { useUser } from "../../../../Hooks/useUser";
import { Dispatch, SetStateAction, useState } from "react";
import { ProfileType } from "../../../../Types/General";
import { TalentInviteModal } from "./TalentInviteModal";
import { useMobileView } from "../../../../Hooks/useMobileView";

interface Props {
    profileLocator: string;
    setMode: Dispatch<SetStateAction<'view' | 'edit'>>;
}

export const TalentProfileButton = ({ profileLocator, setMode }: Props) => {
    /* ******************** Hooks ******************** */
    const { type, locator } = useUser();
    const me = profileLocator === locator;
    /* ******************** Variables ******************** */
    const [showInviteModal, setShowInviteModal] = useState(false);
    const { isMobileView } = useMobileView();
    /* ******************** Functions ******************** */
    const getLabel = () => {
        if (me) return 'Edit';
        if (type === ProfileType.Client) return 'Invite';
    }
    const getHandler = () => {
        if (me) {
            setMode('edit')
        };
        if (type === ProfileType.Client) {
            setShowInviteModal(true)
        };
    } 
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    if (type === ProfileType.Talent && !me) return null;
    return (
        <>
            <Button 
                variant={'contained'} 
                size={ isMobileView ? 'small' : 'large' }
                onClick={getHandler}
            >
                {getLabel()}
            </Button>
            <TalentInviteModal open={showInviteModal} setOpen={setShowInviteModal} clientId={locator!}/>
        </>
    )
}